// extracted by mini-css-extract-plugin
export default {"overlayContainer":"Worksheet__overlayContainer___T9ntq"};